import React, { useState, useEffect } from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Outlet, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../Components/Footer/Footer'
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../Components/Cart/Cart'
import TitleMeta from '../Components/TitleMeta/TitleMeta';
import NavbarMobile from '../Components/NavbarMobile/NavbarMobile'
import Favoritos from '../Components/Favoritos/Favoritos'
import baseURL from '../Components/url'
import MetaPixelLoader from '../Components/MetaPixel/MetaPixelLoader'
import Developer from '../Components/Developer/Developer'
class ErrorBoundary extends React.Component {
    constructor(props){ super(props); this.state = { hasError: false }; }
    static getDerivedStateFromError(){ return { hasError: true }; }
    componentDidCatch(error, info){ console.error('UI ErrorBoundary:', error, info); }
    render(){ if (this.state.hasError) { return (<div style={{ padding: '16px' }}><h2>Ocurrió un error inesperado</h2><p>Intenta recargar la página o volver atrás.</p></div>); } return this.props.children; }
}

export default function IndexLayout() {



    const isScreenLarge = useMediaQuery('(min-width: 1024px)');
    const location = useLocation();
    const [hideFooter, setHideFooter] = useState(false);
    useEffect(() => {
        const onOpenFav = () => setHideFooter(true);
        const onOpenCart = () => setHideFooter(true);
        const onOpenWpp = () => setHideFooter(true);
        const onCloseAll = () => setHideFooter(false);
        window.addEventListener('open-favoritos', onOpenFav);
        window.addEventListener('open-cart', onOpenCart);
        window.addEventListener('open-whatsapp', onOpenWpp);
        window.addEventListener('close-all-overlays', onCloseAll);
        return () => {
            window.removeEventListener('open-favoritos', onOpenFav);
            window.removeEventListener('open-cart', onOpenCart);
            window.removeEventListener('open-whatsapp', onOpenWpp);
            window.removeEventListener('close-all-overlays', onCloseAll);
        };
    }, []);
    useEffect(() => {
        const k = localStorage.getItem('sessionKey') || (() => { const v = `${Date.now()}-${Math.random().toString(16).slice(2)}`; localStorage.setItem('sessionKey', v); return v; })();
        const beat = () => {
          try{
            const payload = { key: k, ua: navigator.userAgent || '', path: window.location.pathname || '/', ts: Date.now() };
            fetch(`${baseURL}/onlineHeartbeat.php`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
          }catch(_){ }
        };
        beat();
        const i = setInterval(beat, 30000);
        return () => clearInterval(i);
    }, []);
    const path = location.pathname || '';
    const hideFooterByRoute = /^\/productos(?:$|\W)/.test(path) || /^\/producto\//.test(path);
    const showFooter = !hideFooter && !hideFooterByRoute;
    return (
        <ErrorBoundary>
        <div >
            <MetaPixelLoader />
            <TitleMeta />
            <ToastContainer />
            {isScreenLarge ?
                <>
                    <Nabvar />
                    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: 1 }}>
                            <Outlet />
                        </div>
                        <Footer />
                        <Developer />
                    </div>
                    <BtnWhatsapp />
                    <Cart />
                </> :
                <>

                    <div style={{ paddingBottom: '84px', minHeight: 'calc(100vh - 84px)', display: 'flex', flexDirection: 'column' }}>
                        <div style={{ flex: 1 }}>
                            <Outlet />
                        </div>
                        { showFooter && (<Footer />) }
                        { showFooter && (<Developer />) }
                    </div>
                    <NavbarMobile />
                    <Favoritos />
                    <BtnWhatsapp />
                    <Cart />
                </>}

            

        </div>
        </ErrorBoundary>
    );
}
